import axios from '@/plugins/http/axios.js';
import config from "@/views/products/config/product_api.js";
import PathUri from '@/utils/path_uri';
const _pathUri = new PathUri(config.port, config.context);
export const service = {
    
    getCountryPhoneCode : (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/countryCode`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
};